import ssoImg1 from "./../../../../assets/images/overview-img-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/overview-img-2.png"; // Adjust the path as necessary

function SmallVesselsSafetyOverviewTab() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Small vessels safety{" "}
        <span className="text-orange-ef3e33 font-400"> overview </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="mb-4">
            The South African Maritime Safety Authority (SAMSA) is responsible
            to the Minister of Transport, by ways of the SAMSA Act, effective 01
            April 1998. SAMSA was charged with the administration of identified
            Acts and Regulations which includes the Merchant Shipping (National
            Small Vessel Safety) Regulations, 2007.
          </p>

          <p className="mb-4">
            The Merchant Shipping (National Small Vessel Safety) Regulations,
            2007 (as amended), apply to commercial small vessels{" "}
            <i className="bi bi-chevron-left"></i> 25 GT and pleasure vessels{" "}
            <i className="bi bi-chevron-left"></i> 100 GT in all South African
            tidal and sea areas, as well as all vessels regardless of their size
            on inland waters.
          </p>

          <p className="mb-4">
            On tidal waters and sea areas the regime has already applied since
            2002. On inland waters, the regulations regarding the certification
            of skippers and the marking and certification of certain vessels
            have applied since August 2008, and the design and construction
            requirements for small vessels have applied since August 2009.
          </p>


        </div>

        <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-5">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
            </div>
            {/* <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={ssoImg2} className="img-fluid rounded-1" alt="" />
            </div> */}
          </div>

        </div> </div>
         <div className="col-lg">
        <p className="mb-4">
          Applicable Acts and Regulations therefore define the minimum
          requirements and standards applicable to small vessels. Formal
          interpretation of Acts and Regulations and clarification of SAMSA
          policy is promulgated to interested/involved parties by Marine
          Notices or Marine Information Notices which can be found on the
          SAMSA website.
        </p>

        <p className="mb-4">
          The “Centre for Boating" is the entity within SAMSA responsible for
          carrying out the mandate delegated to SAMSA by the Merchant Shipping
          Act, 1951, in as far as it applies to small vessels and inland
          waters and more specifically the implementation of the Merchant
          Shipping (National Small Vessel Safety) Regulations 2007.
        </p>

        <p>
          The areas of responsibility delegated to each SAMSA office can be
          found in Marine Notice 8 of 2022 and are as follows: 
        </p>
        <div className="col-12">
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >
                  Northern Region
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3"><b className="d-block">​Principal Officer Location</b> Pretoria</p>

                  <p className="mb-3"><b className="d-block">​Area of Responsibility <span className="text-orange-ef3e33">(inland)</span></b> North West, Gauteng, Limpopo, Mpumalanga, including Part of<br className="d-none d-md-block" /> Northern Free State (Vaal Triangle: i.e. Vaal Dam and Vaal River)​</p>
                  <p className="font-17 text-primary-color">​(012) 366 2600</p>
                  {/* <p ><b className="d-block">Contact details</b>  */}
                  <p className="font-17 text-primary-color">Email: <a href='mailto:inspections@samsa.org.za'>inspections@samsa.org.za</a></p>
                  
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="false"
                  aria-controls="blackTabTwo"
                >
                  Eastern  Region
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <div className="row g-3 g-sm-3">
                    <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>​Richards Bay</b></p>
                      <p className="font-17 text-primary-color">Tugela River to Ponta do Oura - including Tugela River</p>
                      <p className="font-17 text-primary-color">E​​Kwa-Zulu Natal</p>
                      <p className="font-17 text-primary-color">​(035) 788 0068</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:​samsarb@samsa.org.za'>​samsarb@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>Durban</b></p>
                      <p className="font-17 text-primary-color">​Port Edward to Tugela River – including Port Edward</p>
                      <p className="font-17 text-primary-color">​​Kwa-Zulu Natal</p>
                      <p className="font-17 text-primary-color">(031) 307 1501</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:​durbanops@samsa.org.za'>​durbanops@samsa.org.za</a></p>
                    </div>
                  </div><br />
                  
                </div>
                



              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >
                  Southern Region
                </button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <div className="accordion-body">
                  <div className="row g-3 g-sm-3">
                    <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>East London</b></p>
                      <p className="font-17 text-primary-color">Kariega River (Kenton-on-Sea) to Port Edward - excluding Kariega River and Port Edward</p>
                      <p className="font-17 text-primary-color">Eastern Cape, Free State</p>
                      <p className="font-17 text-primary-color">(043) 722 4120</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:elreception@samsa.org.za'>​selreception@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>Port of Ngqura (Coega)</b></p>
                      <p className="font-17 text-primary-color">Port of Ngqura (Coega)</p>
                      <p className="font-17 text-primary-color"></p>
                      <p className="font-17 text-primary-color">(079) 512 1017</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:ponreception@samsa.org.za'>ponreception@samsa.org.za</a></p>
                    </div>
                  </div><br />
                  <div className="row g-3 g-sm-3">
                    <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>​Gqeberha (Port Elizabeth)</b></p>
                      <p className="font-17 text-primary-color">Bloukransrivier to Kariega river (Kenton-on-Sea) - including Kariega River</p>
                      <p className="font-17 text-primary-color">Eastern Cape, Free State</p>
                      <p className="font-17 text-primary-color">​(041) 585 0051</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:​pereception@samsa.org.za'>​pereception@samsa.org.za</a></p>
                    </div>     
                     <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>Mossel Bay</b></p>
                      <p className="font-17 text-primary-color">​Cape Agulhas to Bloukransrivier - including Bloukransrivier</p>
                      <p className="font-17 text-primary-color">​Eastern Cape, Free State</p>
                      <p className="font-17 text-primary-color">(044) 690 4201​</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:​mbreception@samsa.org.za'>​mbreception@samsa.org.za</a></p>
                    </div>                
                  </div>
                </div>

                </div>

              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabFour"
                  aria-expanded="false"
                  aria-controls="blackTabFour"
                >
                  Western Region
                </button>
              </h2>
              <div
                id="blackTabFour"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <div className="row g-3 g-sm-3">
                    <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>​Cape Town</b></p>
                      <p className="font-17 text-primary-color">Yzerfontein to Cape Agulhas</p>
                      <p className="font-17 text-primary-color">Northern Cape, Western Region</p>
                      <p className="font-17 text-primary-color">(021) 421 6170</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:​samsacpt@samsa.org.za'>​samsacpt@samsa.org.za</a></p>
                    </div>

                    <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>Saldanha Bay</b></p>
                      <p className="font-17 text-primary-color">​Groen River to Yzerfontein - including Yzerfontein</p>
                      <p className="font-17 text-primary-color">Northern Cape, Western Region</p>
                      <p className="font-17 text-primary-color">(022) 714 1612</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:saldanhabayoffice@samsa.org.za'>saldanhabayoffice@samsa.org.za</a></p>
                    </div>
                  </div><br />
                  <div className="row g-3 g-sm-3">
                    <div className="col-lg-5 col-md-6 col-sm-6">
                      <p className="font-17 text-primary-color"><b>​Port Nolloth</b></p>
                      <p className="font-17 text-primary-color">​Orange River to Groen Rivier - including Groen Rivier</p>
                      <p className="font-17 text-primary-color">Northern Cape, Western Region</p>
                      <p className="font-17 text-primary-color">​(027) 851 7695</p>
                      <p className="font-17 text-primary-color">Email: <a href='mailto:portnolloth@samsa.org.za'>portnolloth@samsa.org.za</a></p>
                    </div>
                  </div>
                </div>



              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SmallVesselsSafetyOverviewTab;
